import { lazy, Suspense } from "react";
import { SpinnerView } from "../elements/Spinners";

// Lazy load all Portfolio Intelligence containers
const PortfolioOverviewContainer = lazy(() =>
  import(
    "../containers/PortfolioIntelligence/containers/VentureRadarContainer"
  ).then((m) => ({ default: m.PortfolioOverviewContainer }))
);

const PortfolioCompaniesContainer = lazy(() =>
  import(
    "../containers/PortfolioIntelligence/containers/PortfolioCompaniesContainer"
  ).then((m) => ({ default: m.PortfolioCompaniesContainer }))
);

const PortfolioCompanyDetailContainer = lazy(() =>
  import(
    "../containers/PortfolioIntelligence/containers/PortfolioCompanyDetailContainer"
  ).then((m) => ({ default: m.PortfolioCompanyDetailContainer }))
);

const CoInvestorNetworkContainer = lazy(() =>
  import(
    "../containers/PortfolioIntelligence/containers/CoInvestorNetworkContainer"
  ).then((m) => ({ default: m.CoInvestorNetworkContainer }))
);

// Wrap each component with Suspense for consistent loading UX
const withSuspense = (Component: React.LazyExoticComponent<any>) => (
  <Suspense fallback={<SpinnerView message="Loading..." />}>
    <Component />
  </Suspense>
);

export const portfolioIntelligenceRoutes = [
  { path: "/venture-radar", element: withSuspense(PortfolioOverviewContainer) },
  {
    path: "/portfolio-companies",
    element: withSuspense(PortfolioCompaniesContainer),
  },
  {
    path: "/portfolio-companies/:id",
    element: withSuspense(PortfolioCompanyDetailContainer),
  },
  {
    path: "/co-investor-network",
    element: withSuspense(CoInvestorNetworkContainer),
  },
];
